import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  KeyboardFocusModule,
  OutletModule,
  PageLayoutModule,
  SkipLinkDirective,
  StorefrontComponent,
} from 'haba-storefrontlib';
import { LoginModalComponent } from '../authentication/login-modal/login-modal.component';
import { CheckoutFooterComponent } from '../footer/checkout-footer/checkout-footer.component';
import { FooterComponent } from '../footer/footer.component';
import { CheckoutHeaderComponent } from '../header/checkout-header/checkout-header.component';
import { HeaderComponent } from '../header/header.component';
import { SkipLinkComponent } from '../layout/a11y/skip-link/skip-link.component';
import { GlobalMessageCustomComponent } from '../misc/global-message/global-message.component';

@Component({
  selector: 'app-haba-storefront',
  templateUrl: './haba-storefront.component.html',
  styleUrls: ['./haba-storefront.component.scss'],
  imports: [
    PageLayoutModule,
    OutletModule,
    KeyboardFocusModule,
    NgIf,
    HeaderComponent,
    CheckoutHeaderComponent,
    GlobalMessageCustomComponent,
    RouterOutlet,
    NgClass,
    FooterComponent,
    CheckoutFooterComponent,
    LoginModalComponent,
    SkipLinkComponent,
    SkipLinkDirective,
  ],
})
export class HabaStorefrontComponent extends StorefrontComponent {
  @Input() isCheckout: boolean;
  @Input() isOrderConfirmation: boolean;

  //do nothing when pressing Escape, the default behavior was a bug https://jira.habafamilygroup.com/browse/HNBCC-1858
  handleEscape() {}
}
